var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tabs",
    { attrs: { options: { useUrlFragment: false }, id: "notification-tab" } },
    [
      _c("br"),
      _vm._v(" "),
      _c("tab", { attrs: { name: _vm.notificationsTabName } }, [
        _c("form", { staticClass: "form-inline" }, [
          _c(
            "div",
            {
              staticClass: "form-group",
              staticStyle: { "margin-bottom": "5px" }
            },
            [
              _c("font-awesome-icon", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.top-center",
                    value: {
                      content: _vm.globalSettingToolTip,
                      trigger: "hover click"
                    },
                    expression:
                      "{content: globalSettingToolTip, trigger:'hover click'}",
                    modifiers: { "top-center": true }
                  }
                ],
                attrs: { icon: "question-circle" }
              }),
              _vm._v(" " + _vm._s(_vm.globalSettingText) + "\n\t\t\t\t"),
              _c(
                "select",
                {
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      return _vm.$emit("changeGlobal", $event.target.value)
                    }
                  }
                },
                _vm._l(_vm.options.GLOBAL_SETTINGS, function(setting) {
                  return _c(
                    "option",
                    {
                      key: setting.GLOBAL_SETTING_CODE,
                      domProps: {
                        value: setting.GLOBAL_SETTING_CODE,
                        selected:
                          setting.GLOBAL_SETTING_CODE === _vm.globalSetting
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(setting.GLOBAL_SETTING_DESC) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.globalSetting === "S",
                  expression: "globalSetting === 'S'"
                }
              ],
              staticClass: "col-md-6 col-sm-12 details-notification pull-right"
            },
            _vm._l(_vm.options.WORKFLOW_SOURCES, function(
              option,
              systemOptionIndex
            ) {
              return _c("span", { key: "display_" + systemOptionIndex }, [
                _c(
                  "div",
                  {
                    staticClass: "row",
                    staticStyle: { "margin-bottom": "5px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-1",
                        staticStyle: {
                          "padding-top": "10px",
                          "padding-bottom": "10px",
                          "text-align": "right"
                        }
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(systemOptionIndex + 1) +
                              ")\n\t\t\t\t\t\t\t"
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "panel-heading-notification col-xs-11" },
                      [
                        _c(
                          "strong",
                          { staticStyle: { "margin-left": "5px" } },
                          [
                            option.SOURCE_TYPE === "email"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "method-name",
                                    staticStyle: {
                                      display: "inline",
                                      "margin-right": "40px"
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: "envelope",
                                        "aria-hidden": "true"
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.emailText) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            option.SOURCE_TYPE === "phone"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "method-name",
                                    staticStyle: {
                                      display: "inline",
                                      "margin-right": "15px"
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: "phone",
                                        "aria-hidden": "true"
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.voiceCallText) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            option.SOURCE_TYPE === "sms"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "method-name",
                                    staticStyle: {
                                      display: "inline",
                                      "margin-right": "50px"
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: "sms",
                                        "aria-hidden": "true"
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.smsText) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(
                          " " + _vm._s(option.SOURCE_DESC) + "\n\t\t\t\t\t\t"
                        )
                      ]
                    )
                  ]
                )
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-10 padding-left-0" }, [
              _c("strong", [_vm._v(_vm._s(_vm.notificationsText))])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-md-2 padding-right-0",
                staticStyle: { "text-align": "right" }
              },
              [
                _c("strong", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.subscribedText) +
                      "\n\t\t\t\t\t"
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              _vm.globalSetting === "S"
                ? [
                    _vm._l(_vm.options.TYPES, function(type, index) {
                      return [
                        _c("div", { key: "system_default_options_" + index }, [
                          index
                            ? _c(
                                "div",
                                {
                                  key: "static_" + type.NOTIFICATION_TYPE_ID,
                                  staticClass: "row row-striped workflow",
                                  class: {
                                    "bottom-row-striped":
                                      +index + 1 === _vm.options.TYPES.length
                                  }
                                },
                                [
                                  _c("div", { staticClass: "col-md-10" }, [
                                    _c("p", {
                                      staticClass: "text-blue medium-text",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.getTitle(type))
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  !!_vm.preferences.SUBSCRIPTIONS[index]
                                    ? _c(
                                        "div",
                                        { staticClass: "col-md-2" },
                                        [
                                          type.IS_CHECKABLE !== "N"
                                            ? _c("sapphire-toggle", {
                                                staticStyle: {
                                                  display: "inline",
                                                  float: "right"
                                                },
                                                attrs: {
                                                  value:
                                                    _vm.preferences
                                                      .SUBSCRIPTIONS[index]
                                                      .SUBSCRIBED_FLG,
                                                  cssColors: true,
                                                  ariaLabel: _vm.getTitle(type)
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.changedData(
                                                      type.NOTIFICATION_TYPE_ID
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.preferences
                                                      .SUBSCRIPTIONS[index]
                                                      .SUBSCRIBED_FLG,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.preferences
                                                        .SUBSCRIPTIONS[index],
                                                      "SUBSCRIBED_FLG",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "preferences.SUBSCRIPTIONS[index].SUBSCRIBED_FLG"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ])
                      ]
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.globalSetting === "D"
                ? [
                    _vm._l(_vm.options.TYPES, function(type, index) {
                      return [
                        index === 0
                          ? _c(
                              "panel-basic",
                              {
                                key: "my_default_notifications_" + index,
                                staticClass: "no-after",
                                attrs: {
                                  id: "default_notification_workflow",
                                  title: _vm.getTitle(type),
                                  collapsable: true,
                                  useCollapseExpandCarrots: false
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function() {
                                        return [
                                          !!_vm.preferences.SUBSCRIPTIONS[index]
                                            ? _c(
                                                "span",
                                                { staticClass: "no-after" },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getTitle(type)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  !!_vm.changedTypes[
                                                    type.NOTIFICATION_TYPE_ID
                                                  ]
                                                    ? _c("font-awesome-icon", {
                                                        staticClass:
                                                          "text-yellow",
                                                        attrs: {
                                                          icon: "info-circle"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _vm._l(
                                  _vm.preferences.SUBSCRIPTIONS[index]
                                    .WORKFLOWS,
                                  function(workflow, workflowIndex) {
                                    return _c("step-panel", {
                                      key: "workflow_step_" + workflowIndex,
                                      attrs: {
                                        workflow: workflow,
                                        sources: _vm.options.WORKFLOW_SOURCES,
                                        stepNumber: workflowIndex + 1,
                                        addVoiceCallText: _vm.addVoiceCallText,
                                        contactAtText: _vm.contactAtText,
                                        addEmailText: _vm.addEmailText,
                                        emailText: _vm.emailText,
                                        smsTextMessage: _vm.smsTextMessage,
                                        addSMSTextMessageText:
                                          _vm.addSMSTextMessageText,
                                        voiceCallText: _vm.voiceCallText
                                      },
                                      on: {
                                        updateChange: function($event) {
                                          return _vm.changedData(
                                            type.NOTIFICATION_TYPE_ID
                                          )
                                        }
                                      }
                                    })
                                  }
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "row text-center" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-default btn-gray",
                                      attrs: {
                                        disabled: _vm.canAddWorkflow(
                                          _vm.preferences.SUBSCRIPTIONS[index]
                                            .WORKFLOWS
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.addWorkFlow(
                                            type.NOTIFICATION_TYPE_ID,
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "plus" }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.addNewStepText) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { key: "system_default_options_" + index }, [
                          index
                            ? _c(
                                "div",
                                {
                                  key: "static_" + type.NOTIFICATION_TYPE_ID,
                                  staticClass: "row row-striped workflow",
                                  class: {
                                    "bottom-row-striped":
                                      +index + 1 === _vm.options.TYPES.length
                                  }
                                },
                                [
                                  _c("div", { staticClass: "col-md-10" }, [
                                    _c("p", {
                                      staticClass: "text-blue medium-text",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.getTitle(type))
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-2" },
                                    [
                                      type.IS_CHECKABLE !== "N"
                                        ? _c("sapphire-toggle", {
                                            staticStyle: {
                                              display: "inline",
                                              float: "right"
                                            },
                                            attrs: {
                                              value:
                                                _vm.preferences.SUBSCRIPTIONS[
                                                  index
                                                ].SUBSCRIBED_FLG,
                                              cssColors: true,
                                              ariaLabel: _vm.getTitle(type)
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.changedData(
                                                  type.NOTIFICATION_TYPE_ID
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.preferences.SUBSCRIPTIONS[
                                                  index
                                                ].SUBSCRIBED_FLG,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.preferences.SUBSCRIPTIONS[
                                                    index
                                                  ],
                                                  "SUBSCRIBED_FLG",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "preferences.SUBSCRIPTIONS[index].SUBSCRIBED_FLG"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.globalSetting === "C"
                ? _vm._l(_vm.options.TYPES, function(type, index) {
                    return _c(
                      "panel-basic",
                      {
                        key: "options_" + index,
                        staticClass: "no-after",
                        attrs: {
                          id: "default_notification_workflow",
                          title: _vm.getTitle(type),
                          collapsable: true,
                          useCollapseExpandCarrots: false
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  !!_vm.preferences.SUBSCRIPTIONS[index]
                                    ? _c(
                                        "span",
                                        { staticClass: "no-after" },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getTitle(type)
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          !!_vm.changedTypes[
                                            type.NOTIFICATION_TYPE_ID
                                          ]
                                            ? _c("font-awesome-icon", {
                                                staticClass: "text-yellow",
                                                attrs: { icon: "info-circle" }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          type.IS_CHECKABLE !== "N"
                                            ? _c("sapphire-toggle", {
                                                staticStyle: {
                                                  display: "inline",
                                                  float: "right"
                                                },
                                                attrs: {
                                                  value:
                                                    _vm.preferences
                                                      .SUBSCRIPTIONS[index]
                                                      .SUBSCRIBED_FLG,
                                                  cssColors: true,
                                                  ariaLabel: _vm.getTitle(type)
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.changedData(
                                                      type.NOTIFICATION_TYPE_ID,
                                                      index
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.preferences
                                                      .SUBSCRIPTIONS[index]
                                                      .SUBSCRIBED_FLG,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.preferences
                                                        .SUBSCRIPTIONS[index],
                                                      "SUBSCRIBED_FLG",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "preferences.SUBSCRIPTIONS[index].SUBSCRIBED_FLG"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(" "),
                        _vm._l(
                          _vm.preferences.SUBSCRIPTIONS[index].WORKFLOWS,
                          function(workflow, workflowIndex) {
                            return _c("step-panel", {
                              key: "workflow_step_" + workflowIndex,
                              attrs: {
                                workflow: workflow,
                                sources: _vm.options.WORKFLOW_SOURCES,
                                stepNumber: workflowIndex + 1,
                                addVoiceCallText: _vm.addVoiceCallText,
                                contactAtText: _vm.contactAtText,
                                addEmailText: _vm.addEmailText,
                                emailText: _vm.emailText,
                                smsTextMessage: _vm.smsTextMessage,
                                addSMSTextMessageText:
                                  _vm.addSMSTextMessageText,
                                voiceCallText: _vm.voiceCallText
                              },
                              on: {
                                updateChange: function($event) {
                                  return _vm.changedData(
                                    type.NOTIFICATION_TYPE_ID
                                  )
                                }
                              }
                            })
                          }
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-default btn-gray margin-top-5",
                              attrs: {
                                disabled: _vm.canAddWorkflow(
                                  _vm.preferences.SUBSCRIPTIONS[index].WORKFLOWS
                                )
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.addWorkFlow(
                                    type.NOTIFICATION_TYPE_ID,
                                    index
                                  )
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "plus" }
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.addNewStepText) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("br")
                      ],
                      2
                    )
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("h3", [
            _vm._v("\n\t\t\t\t" + _vm._s(_vm.languageSettinsText) + "\n\t\t\t")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "form-group col-md-7" }, [
              _c("strong", [
                _vm._v(
                  "\n\t\t\t\t\t\t" +
                    _vm._s(_vm.defaultVoiceText) +
                    "\n\t\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.preferences.SETTINGS.VOICE_LANGUAGE,
                      expression: "preferences.SETTINGS.VOICE_LANGUAGE"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    input: _vm.setDirty,
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.preferences.SETTINGS,
                        "VOICE_LANGUAGE",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.options.VOICE_LANGUAGES, function(language) {
                  return _c(
                    "option",
                    {
                      key: language.LANGUAGE_CODE,
                      domProps: { value: language.LANGUAGE_CODE }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(language.LANGUAGE_DESC) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "form-group col-md-7" }, [
              _c("strong", [
                _vm._v(
                  "\n\t\t\t\t\t\t" + _vm._s(_vm.defaultSMSText) + "\n\t\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.preferences.SETTINGS.SMS_LANGUAGE,
                      expression: "preferences.SETTINGS.SMS_LANGUAGE"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    input: _vm.setDirty,
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.preferences.SETTINGS,
                        "SMS_LANGUAGE",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.options.TEXT_LANGUAGES, function(language) {
                  return _c(
                    "option",
                    {
                      key: language.LANGUAGE_CODE,
                      domProps: { value: language.LANGUAGE_CODE }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(language.LANGUAGE_DESC) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "form-group col-md-7" }, [
              _c("strong", [
                _vm._v(
                  "\n\t\t\t\t\t\t" +
                    _vm._s(_vm.defaultEmailText) +
                    "\n\t\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.preferences.SETTINGS.EMAIL_LANGUAGE,
                      expression: "preferences.SETTINGS.EMAIL_LANGUAGE"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    input: _vm.setDirty,
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.preferences.SETTINGS,
                        "EMAIL_LANGUAGE",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.options.TEXT_LANGUAGES, function(language) {
                  return _c(
                    "option",
                    {
                      key: language.LANGUAGE_CODE,
                      domProps: { value: language.LANGUAGE_CODE }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(language.LANGUAGE_DESC) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("br")
        ])
      ]),
      _vm._v(" "),
      _c(
        "tab",
        { attrs: { name: _vm.broadcastsTabName } },
        [
          _c("broadcast-tab", {
            attrs: {
              broadcastsData: _vm.broadcastsData,
              broadcastHistoryText: _vm.broadcastHistoryText,
              noBroadcastMessage: _vm.noBroadcastMessage,
              voiceCall: _vm.voiceCallText,
              phoneText: _vm.phoneText,
              answeredByText: _vm.answeredByText,
              durationsText: _vm.durationsText,
              phoneMessageText: _vm.phoneMessageText,
              showEnglishText: _vm.showEnglishText,
              noAudioSupportText: _vm.noAudioSupportText,
              smsTextMessage: _vm.smsTextMessage,
              smsTestMessageColon: _vm.smsTestMessageColon,
              emailAllCaps: _vm.emailAllCaps,
              emailWithColon: _vm.emailWithColon,
              subjectLineWithColon: _vm.subjectLineWithColon
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }